// src/pages/organismos/GranBiblioteca.jsx

const GranBiblioteca = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1507842217343-583bb7270b66?q=80&w=2000&auto=format&fit=crop')" }} // Imagen de biblioteca clásica
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Organismos Culturales
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-4">
            Gran Biblioteca
          </h1>
          <h2 className="font-serif text-2xl md:text-3xl italic font-light text-gray-300 animate-fade-in [animation-delay:0.5s] mb-8">
            "M.·. R.·. H.·. Eduardo Lavergne"
          </h2>
        </div>
      </section>

      {/* Contenido Principal: Dos Columnas (Autoridades y Horarios/Contacto) */}
      <section className="relative z-20 max-w-[85rem] mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          
          {/* Columna Izquierda: Bibliotecarios */}
          <div className="flex flex-col gap-6">
            <div className="mb-6 border-b border-white/10 pb-4">
              <h3 className="font-serif text-2xl md:text-3xl text-white">
                Gestión Administrativa
              </h3>
              <div className="flex items-center gap-4 mt-3">
                <span className="text-gray-400 font-light text-sm tracking-widest">
                  Periodo 2024 - 2026
                </span>
                <span className="text-[#C5A059] text-[10px] tracking-widest uppercase border border-[#C5A059]/30 px-2 py-1">
                  Decreto 142-021 GLP
                </span>
              </div>
            </div>

            {/* Gran Bibliotecario */}
            <div className="bg-[#0a0a0a] border-l-2 border-[#C5A059] p-8 shadow-lg group hover:bg-white/[0.02] transition-colors duration-300">
              <span className="text-[#C5A059] text-xs tracking-[0.2em] uppercase block mb-4 font-semibold">
                Gran Bibliotecario
              </span>
              <p className="text-gray-500 text-xs tracking-widest uppercase mb-1">
                R.·. H.·.
              </p>
              <h4 className="font-serif text-2xl text-white mb-4">
                Ismael Espinoza Donayre
              </h4>
              <p className="text-gray-400 text-sm font-light tracking-wide">
                Logia N° 177
              </p>
            </div>

            {/* Gran Bibliotecario Adjunto */}
            <div className="bg-[#0a0a0a] border border-white/5 p-8 group hover:border-[#C5A059]/30 transition-colors duration-300">
              <span className="text-gray-400 text-xs tracking-[0.2em] uppercase block mb-4 font-semibold">
                Gran Bibliotecario Adjunto
              </span>
              <p className="text-gray-500 text-xs tracking-widest uppercase mb-1">
                R.·. H.·.
              </p>
              <h4 className="font-serif text-xl text-gray-500 italic">
                Por Designar
              </h4>
            </div>
          </div>

          {/* Columna Derecha: Contacto y Atención */}
          <div className="flex flex-col gap-6">
            <div className="mb-6 border-b border-white/10 pb-4">
              <h3 className="font-serif text-2xl md:text-3xl text-white">
                Información y Servicios
              </h3>
            </div>

            {/* Tarjeta de Contacto */}
            <div className="bg-gradient-to-br from-[#0a0a0a] to-[#111111] border border-white/5 p-8 md:p-10 shadow-xl">
              
              <div className="mb-8">
                <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-3">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Dirección
                </span>
                <p className="text-gray-300 font-light text-base md:text-lg">
                  Av. José Gálvez Barrenechea N°599
                  <span className="block text-gray-500 text-sm mt-1">San Isidro, Lima</span>
                </p>
              </div>

              <div className="mb-8">
                <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-3">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  Central Telefónica
                </span>
                <p className="text-gray-300 font-light text-base md:text-lg">
                  618-5454 <span className="text-[#C5A059]">|</span> Anexo: 203
                </p>
              </div>

              <div>
                <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-3">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  Correo Electrónico
                </span>
                <a href="mailto:granbiblioteca@glperu.org.pe" className="text-gray-300 hover:text-[#C5A059] transition-colors font-light text-base md:text-lg break-all">
                  granbiblioteca@glperu.org.pe
                </a>
              </div>

            </div>

            {/* Tarjeta de Horarios */}
            <div className="bg-[#050505] border border-white/5 p-8 md:p-10">
              <h4 className="text-white font-serif text-xl mb-6 flex items-center gap-3">
                <svg className="w-5 h-5 text-[#C5A059]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Horarios de Atención
              </h4>
              
              <div className="space-y-6">
                <div>
                  <span className="block text-gray-500 text-xs tracking-widest uppercase mb-1">Días de Atención</span>
                  <p className="text-gray-300 font-medium">De Lunes a Viernes</p>
                </div>
                
                <div className="pl-4 border-l border-white/10">
                  <span className="block text-[#C5A059] text-xs tracking-widest uppercase mb-1">Empleado de la GLP</span>
                  <p className="text-gray-300 font-light">De 15:00 a 22:00 Horas</p>
                </div>

                <div className="pl-4 border-l border-white/10">
                  <span className="block text-[#C5A059] text-xs tracking-widest uppercase mb-1">Gran Bibliotecario</span>
                  <p className="text-gray-300 font-light">De 20:00 a 22:00 Horas</p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
};

export default GranBiblioteca;